module.exports = __webpack_public_path__ + "img/index-right-logo.6585dd33.png";